// ts-rest contract for Comply > SMCR Directory.
// Projects the `smcr_directory` rows (firm-infrastructure table) onto the
// view-facing personnel + prescribed-responsibilities shapes. The controller is
// the mapping seam: it translates the stored `functionType` / conduct-rules /
// attestation values onto the display vocabulary the page renders.

import { initContract } from '@ts-rest/core';
import { z } from 'zod';

const c = initContract();

export const smcrPersonnelDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
    role: z.string(),
    smfNumber: z.string().optional(),
    functionType: z.enum([
        'Senior Manager Function',
        'Certification Function',
        'Conduct Rules Only',
    ]),
    fitAndProperStatus: z.enum(['Current', 'Due', 'Overdue']),
    conductRulesStatus: z.enum(['Completed', 'Due', 'Overdue']),
    conductRulesTraining: z.enum(['Completed', 'Due', 'Overdue']),
    nextAttestation: z.string(),
    breachesInPeriod: z.number(),
});
export type SmcrPersonnelDto = z.infer<typeof smcrPersonnelDtoSchema>;

export const smcrResponsibilityDtoSchema = z.object({
    id: z.string(),
    code: z.string(),
    description: z.string(),
    holder: z.string(),
    smfFunction: z.string(),
    evidenceStatus: z.string(),
});
export type SmcrResponsibilityDto = z.infer<typeof smcrResponsibilityDtoSchema>;

export const smcrDirectoryResponseSchema = z.object({
    personnel: z.array(smcrPersonnelDtoSchema),
    responsibilities: z.array(smcrResponsibilityDtoSchema),
});
export type SmcrDirectoryResponse = z.infer<typeof smcrDirectoryResponseSchema>;

const errorBody = z.object({ error: z.string() });

export const complySmcrContract = c.router(
    {
        get: {
            method: 'GET',
            path: '/comply/smcr-directory',
            responses: { 200: smcrDirectoryResponseSchema, 403: errorBody },
            summary: 'SMCR personnel register + prescribed-responsibilities map.',
        },
    },
    { pathPrefix: '/api', strictStatusCodes: false },
);
